import React, { createContext, useState } from "react";

export const toggleContext = createContext();

function ToggleNavbar(props) {
  const [toggleSidebar, setToggleSidebar] = useState(false);

  function openSidebar() {
    setToggleSidebar((prv) => !prv);
  }
  if (toggleSidebar) {
    document.body.classList.add("sidebar-enable");
  } else {
    document.body.classList.remove("sidebar-enable");
  }

  return (
    <toggleContext.Provider value={{ toggleSidebar, openSidebar }}>
      {props.children}
    </toggleContext.Provider>
  );
}

export default ToggleNavbar;
